<script lang="ts">
  export let colour: string = '#808A9F';
  export let width: number = 24;
  export let height: number = 24;
  export let svgClass: string = '';
</script>

<svg
  class={svgClass}
  {width}
  {height}
  viewBox="0 0 42 42"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    id="Icon"
    d="M16 27V15M26 27V15M41 21C41 32.0457 32.0457 41 21 41C9.9543 41 1 32.0457 1 21C1 9.9543 9.9543 1 21 1C32.0457 1 41 9.9543 41 21Z"
    stroke={colour}
    style="stroke:{colour};stroke:{colour};stroke-opacity:1;"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
